<template>
  <ModuleSection :title="$route.meta.title">
    <p style="margin-top: -20px;color:#A1A7C4;">{{ $t('为保证该笔汇款正常汇出，请您提供以下资金证明等信息给CBiBank进行报备') }}</p>
    <!-- 表单 -->
    <el-form
      style="margin-top: 40px"
      ref="submitForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      label-width="180px">
      <el-form-item
        :label="$t('汇出汇款账号')"
        prop="decAccount"
      >
        <el-select
          v-model="formData.decAccount"
          :placeholder="$t('请选择')"
          disabled
          class="form-item"
          @change="handleAccountSelect">
          <el-option
            v-for="(item, index) in msbdAccountMap"
            :key="index"
            :label="item | translateFilter"
            :value="index" />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('汇款金额')"
        prop="decAmount"
      >
        <div style="display: flex; align-items: center;">
          <el-input
            v-model="formData.decAmount"
            :placeholder="$t('请输入汇款金额')"
            disabled
            type="number"
            class="form-item"
            @blur="handleAmountBlur"
          />
          <span
            style="margin-left: 20px;font-size: 14px;color: #5A607F;">
            {{ formData.currency }}
          </span>
        </div>
      </el-form-item>
     <el-form-item
        :label="$t('汇款用途/目的')"
        prop="purpose"
      >
        <el-input
          :value="$t($_params.payUseList[formData.purpose]) || formData.purpose"
          disabled
          :placeholder="$t('如同账户转账、贸易汇款等')"
          :maxlength="140"
          :show-word-limit="true"
          type="textarea"
          class="form-item"
          @blur="handlePurposeBlur"
        />
      </el-form-item>
      <el-form-item
        :label="$t('收款人企业性质')"
        prop="payCompanyType"
      >
        <el-select
          v-model="formData.payCompanyType"
          :placeholder="$t('请选择')"
          class="form-item">
          <el-option
            v-for="(item, index) in INTERBANK_COMPANY_TYPE_LIST"
            :key="index"
            :label="$t(item)"
            :value="index" />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('与收款人关系')"
        prop="relationship"
      >
        <el-select
          v-model="formData.relationship"
          :placeholder="$t('请选择与收款人关系')"
          class="form-item">
          <el-option
            v-for="(item, index) in INTERBANK_RELATION_SHIP"
            :key="index"
            :label="$t(item)"
            :value="index" />
        </el-select>
      </el-form-item>
      <!-- 上传组件 客户在白名单中的话无需查看和上传文件 -->
      <el-form-item
        v-if="!customerIsInAllowList"
        :label="$t('资金证明材料')"
        prop="fileList"
      >
        <UploadFile
          :file-list="formData.fileList"
          class="form-item">
        </UploadFile>
      </el-form-item>
      <!-- 示例 MSB MSBC类账户需要示例，目前这俩类账户已下线-->
      <!-- <el-form-item
        :label="$t('示例')">
        <ViewFile
          :file-list="sampleList">
        </ViewFile>
      </el-form-item> -->
      <!-- tip -->
      <el-form-item>
        <div style="display: flex; align-items: flex-start; width: 500px;">
          <span style="color:#F34359; line-height: 20px; margin-right: 9px;">*</span>
          <div>
            <p class="tip-item">
              {{ $t('上传能证明该笔资金汇款用途/目的的文件，包括但不限于发票、合同或者协议、报关单、提货单') }}
            </p>
            <p class="tip-item">
              {{ $t('单个xls，pdf、jpg、jpeg、png等文件不超过10M，最多上传10个文件') }}
            </p>
            <p class="tip-item">
              {{ $t('明确汇款公司有利于提高收款审核效率') }}
            </p>
          </div>
        </div>
      </el-form-item>
      <!-- 按钮 -->
      <el-form-item>
        <div>
          <el-button class="btn" @click="$router.go(-1)">{{ $t('返回') }}</el-button>
          <el-button
            type="primary"
            class="btn"
            @click="handleGoDeclare()">
            {{ $t('去申报') }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </ModuleSection>
</template>

<script>
import { INTERBANK_COMPANY_TYPE_LIST, INTERBANK_RELATION_SHIP } from '../../components/constants'
import { submitOutwardTransferConfirm } from '../../api'
import { getSignDataByObj } from '@/utils/USBKeyUtil'
import { mapState, mapGetters } from 'vuex'
const pattern = /^[a-zA-Z\d /.,'?:()\-+{}]{1,140}$/
export default {
  name: 'Setp3',
  data () {
    // 电商类账户有特定的申报页面 所以这里的账户不再显示电商类账户
    const msbdAccountMap = this.$_params.getSessionAccountSelect_obj('ALL', true, 0)
    return {
      INTERBANK_COMPANY_TYPE_LIST,
      INTERBANK_RELATION_SHIP,
      msbdAccountMap,
      /* 路由信息 */
      // Add Detail Update
      type: '',
      accNo: '',
      reportId: '',
      /* 新增 */
      formData: {
        decAccount: '',
        decAmount: '',
        currency: '',
        payCompanyType: '',
        relationship: '',
        purpose: '',
        fileList: []
      },
      /* 回显 */
      checkDetail: {}
    }
  },
  created () {
    const { payAccount, payAmount, payUse } = this.$route.query
    this.formData.decAccount = payAccount
    this.formData.decAmount = payAmount
    this.formData.purpose = payUse
    // 如果是白名单客户的话，在formData的fileList中添加一份固定文件
    const { customerIsInAllowList, PROJECT_URL } = this
    const { customerId } = this.loginInfo
    if (customerIsInAllowList) {
      this.formData.fileList.push({
        openByBrowser: true,
        name: customerId + '.pdf',
        path: PROJECT_URL + 'download/' + customerId + '.pdf'
      })
    }
  },
  computed: {
    ...mapState('login', ['loginInfo']),
    ...mapGetters(['customerIsInAllowList', 'PROJECT_URL']),
    rules () {
      return {
        decAccount: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        decAmount: [
          { required: true, trigger: 'blur', validator: this.amountValidator }
        ],
        purpose: [
          { required: true, trigger: 'blur', validator: this.purposeValidator }
        ],
        payCompanyType: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        relationship: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        fileList: [
          { required: true, message: this.$t('请上传'), trigger: 'change' }
        ]
      }
    },
    amountValidator () {
      return (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('请输入')))
          return
        }
        const { currency } = this.formData
        if ((currency === 'JPY' || currency === 'KRW') && (!/.00$/.test(value))) {
          callback(new Error(this.$t('日元和韩元账户汇款金额只能为整数，请重新输入！')))
          return
        }
        callback()
      }
    },
    purposeValidator () {
      return (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('请输入')))
          return
        }
        if (!pattern.test(value)) {
          callback(new Error(this.$t('您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')))
          return
        }
        callback()
      }
    }
  },
  methods: {
    // 账号
    handleAccountSelect (val) {
      const list = val.split('|')
      this.formData.currency = list[1]
    },
    // 汇款金额
    handleAmountBlur (e) {
      const val = e.target.value
      this.formData.amount = Number(val).toFixed(2)
    },
    // 汇款用途/目的
    handlePurposeBlur (e) {
      const val = e.target.value
      // 空白符转换成空格 &转换成 and
      this.formData.purpose = val.replace(/\s/g, ' ').replace(/&/g, ' and ')
    },
    // 提交申报
    handleGoDeclare () {
      const checkForm = () => new Promise((resolve, reject) => {
        this.$refs.submitForm.validate(valid => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('Check False'))
          }
        })
      })

      const afterCheckDoSumbmit = (signData) => {
        const { fileList, relationship, ...restFormData } = this.formData
        const { agentAbaCode: agentRecBankAba, bsbCode: bsbNo, cnapsCode: cnapsNo, ...resetQuery } = this.$route.query
        submitOutwardTransferConfirm({
          ...resetQuery,
          ...restFormData,
          ...fileList.reduce((acc, next, index) => {
            return { ...acc, ['name' + index]: next.name, ['path' + index]: next.path }
          }, {}),
          relation: relationship,
          agentRecBankAba,
          bsbNo,
          cnapsNo,
          signData,
          session_customerId: this.loginInfo.customerId,
          session_userId: this.loginInfo.userId,
          businessCode: '10200300',
          currentBusinessCode: '10200300',
          logRecordFlag: 1,
          transferName: '跨行转账',
          payType: 'SW',
          tranChannel: '4',
          rmtType: '0',
          recBankType: '1',
          businessType: '1'
        }).then(res => {
          const { recBankName, currencyType, recAccount } = this.$route.query
          this.$router.push({
            name: 'InterBankOutwardStep4',
            query: { ...res, recBankName, currencyType, recAccount }
          })
        })
      }

      const signCheck = () => {
        // 交易名称#transferName|付款账号#payAccount|收款账号#recAccount|收款户名#recAccountName|币种#currencyType|交易金额#payAmount
        const { payAccount, recAccount, recAccountName, currencyType, payAmount } = this.$route.query
        const { customerId, userId } = this.loginInfo
        const info = {
          obviousInfo: {
            交易名称: '跨行转账',
            付款账号: payAccount,
            收款账号: recAccount,
            收款户名: recAccountName,
            币种: currencyType,
            交易金额: payAmount
          },
          hiddenInfo: {
            客户号: customerId,
            用户编号: userId,
            交易代码: '10200300'
          },
          showHiddenColon: true
        }
        return new Promise((resolve, reject) => {
          getSignDataByObj.call(this, info, (signData) => {
            resolve(signData)
          })
        })
      }
      // checkForm().then(() => this.$tconfirm('确认要提交该汇款申报？')).then(() => signCheck()).then((signData) => afterCheckDoSumbmit(signData)).catch(console.error)
      checkForm().then(() => this.$tconfirm('确认要提交该汇款申报？', '提示')).then(() => {
        // 放入到下一个tick中执行验签， 避免验签弹窗覆盖到模态框上
        this.$nextTick(() => {
          signCheck().then((signData) => afterCheckDoSumbmit(signData)).catch(_ => console.error(_))
        })
      }).catch(_ => console.error(_))
    },

    // Update页 重新申报， 交易核查重新申报和去申报是一致的
    handleUpdateDeclare () {
      this.handleGoDeclare()
    }
  }
}
</script>

<style scoped lang="less">
.form-item {
  width: 500px;
}
.tip-item {
  font-size: 12px;
  font-weight: 300;
  color: #A1A7C4;
  line-height: 17px;
}
.btn {
  min-width: 140px;
  height: 40px;
}
.detail-area {
  margin-bottom: 40px;
  border-bottom: 1px solid #E6E9F4;
  .detail-item {
    height: 14px;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 40px;
    }
    /deep/.el-form-item__label {
      line-height: 14px;
    }
    /deep/.el-form-item__content {
      line-height: 14px;
    }
  }
}
</style>
